/**
 * Static registry of dashboard routes (core routes) that have explicit tool ownership
 * This maps route names to their Totem tool IDs
 *
 * NOTE: This is a TEMPORARY solution until we move the tools out of dashboard
 * into their respective domains.
 */
export const DASHBOARD_ROUTE_TOOLS: Record<string, string> = {
  catalog: 'ipp-platform',
  aisles: 'ipp-platform',
  'new-aisle': 'ipp-platform',
  'edit-aisle': 'ipp-platform',
  aisle: 'ipp-platform',
  departments: 'ipp-platform',
  'new-department': 'ipp-platform',
  'edit-department': 'ipp-platform',
  'new-product-request': 'ipp-platform',
  product: 'ipp-platform',
  editProduct: 'ipp-platform',
  search: 'ipp-platform',
  'new-search': 'ipp-platform',
  'search-results': 'ipp-platform',
  delivery: 'ipp-platform',
  pickup: 'ipp-platform',
  scanandpay: 'ipp-platform',
  order: 'ipp-platform',
  reports: 'ipp-platform',
  subscriptions: 'ipp-platform',
  transactions: 'ipp-platform',
  files: 'ipp-platform',
  'alcohol-tlogs': 'ipp-platform',
  stripeSettings: 'ipp-platform',
  storeHoursSettings: 'ipp-platform',
  admin: 'ipp-platform',
  'new-user': 'ipp-platform',
  'edit-user': 'ipp-platform',
  productEditDetails: 'ipp-platform',
  productEditAisles: 'ipp-platform',
  productEditLocations: 'ipp-platform',
  insightsPortal: 'insights-portal-store-labor-performance-tool',
  'store-groups': 'ipp-platform',
  'store-groups-add': 'ipp-platform',
  'store-groups-edit': 'ipp-platform',
  base: 'ipp-platform',
  logout: 'ipp-platform',
  'stripe-connect-callback': 'ipp-platform',
  scope: 'ipp-platform',
  'partner-scoped': 'ipp-platform',
  'retailer-scoped': 'ipp-platform',
  orders: 'ipp-platform',
  settings: 'ipp-platform',
  'retailer-files': 'ipp-platform',
  'log-out': 'ipp-platform',
  public: 'authentication-dashboard-tool',
  app: 'ipp-platform',
  'app-halt': 'ipp-platform',
  'app-halt-redirect': 'ipp-platform',
  'partner-halt-terms': 'ipp-platform',
  'app-halt-account-limited-access': 'ipp-platform',
  'app-halt-auth-service-account-limited-access': 'ipp-platform',
  'app-halt-account-action-required': 'ipp-platform',
  'app-admin': 'ipp-platform',
  'banner-notifications-list': 'notifications-dashboard-tool',
  'platform-notifications-list': 'notifications-dashboard-tool',
  dashboard: 'executive-summary-dashboard-tool',
  'notification-settings': 'notifications-dashboard-tool',
  // Add more dashboard routes with tools here as needed
  // Example: 'dashboard-route-name': 'totem-tool-id',
}
